/**
 * Fullscreen image zoom for Quick View (bulk left photo + standard product media).
 */
(function () {
  if (window.__ffsQuickViewZoom) return;

  let root = null;
  let focusReturn = null;

  function ensure() {
    if (root) return root;
    root = document.createElement('div');
    root.className = 'ffs-qv-lightbox';
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<button type="button" class="ffs-qv-lightbox__backdrop" data-ffs-qv-close aria-label="Close image"></button>' +
      '<div class="ffs-qv-lightbox__dialog" role="dialog" aria-modal="true" aria-label="Product image" tabindex="-1">' +
      '<button type="button" class="ffs-qv-lightbox__close" data-ffs-qv-close aria-label="Close">' +
      '<span aria-hidden="true">&times;</span>' +
      '</button>' +
      '<img class="ffs-qv-lightbox__img" alt="">' +
      '</div>';
    document.body.appendChild(root);

    root.querySelectorAll('[data-ffs-qv-close]').forEach((el) => {
      el.addEventListener('click', close);
    });

    document.addEventListener(
      'keyup',
      (event) => {
        if (event.code !== 'Escape' || !root || root.hidden) return;
        event.stopImmediatePropagation();
        close();
      },
      true
    );

    return root;
  }

  function open(src, alt, opener) {
    if (!src) return;
    const lb = ensure();
    const img = lb.querySelector('.ffs-qv-lightbox__img');
    const dialog = lb.querySelector('.ffs-qv-lightbox__dialog');
    focusReturn = opener || document.activeElement;
    if (img) {
      img.src = src;
      img.alt = alt || 'Product image';
    }
    lb.hidden = false;
    lb.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ffs-qv-lightbox-lock');
    dialog?.focus({ preventScroll: true });
  }

  function close() {
    if (!root || root.hidden) return;
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ffs-qv-lightbox-lock');
    const img = root.querySelector('.ffs-qv-lightbox__img');
    if (img) img.removeAttribute('src');
    if (focusReturn && typeof focusReturn.focus === 'function') {
      focusReturn.focus({ preventScroll: true });
    }
    focusReturn = null;
  }

  function pickSrc(img) {
    if (!img) return '';
    return img.currentSrc || img.src || '';
  }

  document.addEventListener('click', (event) => {
    const zoomBtn = event.target.closest('[data-ffs-qv-zoom]');
    if (zoomBtn) {
      event.preventDefault();
      open(zoomBtn.getAttribute('data-ffs-qv-src'), zoomBtn.getAttribute('data-ffs-qv-alt'), zoomBtn);
      return;
    }

    const mediaImg = event.target.closest('.quick-add-modal .product__media img');
    if (mediaImg) {
      event.preventDefault();
      open(pickSrc(mediaImg), mediaImg.alt || 'Product image', mediaImg);
    }
  });

  window.__ffsQuickViewZoom = { open, close };
})();
